import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FEEDBACK_API } from '../pages/Feedback';
import './FeedbackSummary.scss';

const CATEGORIES = [
  { key: 'food', label: 'Food Quality' },
  { key: 'taste', label: 'Taste & Presentation' },
  { key: 'service', label: 'Staff & Service' },
  { key: 'cleanliness', label: 'Cleanliness' },
  { key: 'ambiance', label: 'Haveli Ambiance' },
  { key: 'value', label: 'Value for Money' },
];

const Stars = ({ rating }) => (
  <span className="fs-stars" aria-label={`${rating} out of 5 stars`}>
    <span className="fs-stars__empty">★★★★★</span>
    <span className="fs-stars__full" style={{ width: `${(rating / 5) * 100}%` }}>★★★★★</span>
  </span>
);

const FeedbackSummary = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetch(FEEDBACK_API)
      .then((res) => (res.ok ? res.json() : null))
      .then(setStats)
      .catch(() => setStats(null));
  }, []);

  if (!stats || !stats.total) return null;

  return (
    <div className="fs-card">
      <div className="fs-overall">
        <div className="fs-overall__score">{stats.overall.toFixed(1)}</div>
        <Stars rating={stats.overall} />
        <div className="fs-overall__count">
          Based on {stats.total} guest {stats.total === 1 ? 'review' : 'reviews'}
        </div>
        <div className="fs-badges">
          <span><strong>{stats.recommend_pct}%</strong> would recommend</span>
          <span><strong>{stats.on_time_pct}%</strong> served on time</span>
        </div>
      </div>

      <div className="fs-categories">
        {CATEGORIES.map((c) => (
          <div className="fs-row" key={c.key}>
            <span className="fs-row__label">{c.label}</span>
            <span className="fs-row__bar">
              <span style={{ width: `${(stats[c.key] / 5) * 100}%` }} />
            </span>
            <span className="fs-row__value">{stats[c.key].toFixed(1)}</span>
          </div>
        ))}
        <Link to="/feedback" className="fs-cta">Share your feedback →</Link>
      </div>
    </div>
  );
};

export default FeedbackSummary;
